/**
 * Composable для управления модалками авторизации
 *
 * Предоставляет удобные методы для открытия различных модалок авторизации
 * и проверки их состояний
 */
export const useAuthModal = () => {
  const authModalStore = useAuthModalStore()

  return {
    // State getters
    isOpen: computed(() => authModalStore.hasOpenModal),
    isLoginModalOpen: computed(() => authModalStore.isLoginModalOpen),
    isRegisterModalOpen: computed(() => authModalStore.isRegisterModalOpen),
    isForgotPasswordModalOpen: computed(() => authModalStore.isForgotPasswordModalOpen),
    currentModal: computed(() => authModalStore.currentModal),

    // Actions
    openLogin: () => authModalStore.openLoginModal(),
    openRegister: () => authModalStore.openRegisterModal(),
    openForgotPassword: () => authModalStore.openForgotPasswordModal(),

    // Switch between modals
    switchToLogin: () => authModalStore.switchToLogin(),
    switchToRegister: () => authModalStore.switchToRegister(),
    switchToForgotPassword: () => authModalStore.switchToForgotPassword(),

    // Close modals
    closeModal: () => authModalStore.closeModal(),
    closeAllModals: () => authModalStore.closeAllModals()
  }
}
